var map = {
	"./1.png": "775a",
	"./2.png": "8e30",
	"./3.png": "1f66",
	"./4.png": "5fa5",
	"./5.png": "c037a",
	"./6.png": "338d",
	"./code_img.png": "2c40",
	"./logo_img.png": "d662",
	"./qem-logo-white.png": "729e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";